import React from "react";

import {
    IconButton,
    InputAdornment,
    TextField,
    makeStyles
} from "@material-ui/core";
import { IconBuscar } from "@portal/arq-portal-core";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(() => ({
    iconBuscarTop: {
        background: 'none !important',
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
        '& .MuiSvgIcon-root': {
            color: '#606060',
        },
        '&:hover .MuiSvgIcon-root': {
            color: '#919191',
        },
        '&:focus .MuiSvgIcon-root, &:active .MuiSvgIcon-root': {
            color: '#DC0028',
        }
    },
    input:{
        '& input:-webkit-autofill, & input:-webkit-autofill:hover,& input:-webkit-autofill:focus,& input:-webkit-autofill:active': {
            transition: 'background-color 5000s ease-in-out 0s',
            WebkitTextFillColor: '#000 !important',
        },
        '& .Mui-focused.MuiInput-underline:after':{
            borderBottom: '2px solid #606060',
        }

    }
}));
export const BuscadorTextField = (props: any) => {

    const [valor, setValor] = React.useState(props.valor ?? "");
    let history = useHistory();

    React.useEffect(() => {
        setValor(props.valor);
    }, [props.valor])

    const handleChange = (event: any) => {
        setValor(event.target.value);
    }
    const handleEnter = (event: any) => {

        if (event.keyCode == 13) {
            search();
        }
    }

    const search = () => {
        if (valor !== "") {
            history.push("/buscar/" + encodeURI(valor));
            if (props.valor == "") setValor("");
            if (props.onClose) props.onClose();
        }
    }
    const classes = useStyles(props);
    return <TextField {...props} id="buscar" placeholder="Buscar" variant="standard"
        className={classes.input}
        value={valor}
        onChange={handleChange}
        onKeyUp={handleEnter}
        InputProps={{
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton className={classes.iconBuscarTop}  type="submit" aria-label="buscar" size="small" onClick={search}>
                        <IconBuscar />
                    </IconButton>
                </InputAdornment>
            ),
        }} />
}